import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '内容分类',
    links: [
      { label: '电视剧', path: '/category/dianshi' },
      { label: '电影', path: '/category/dianying' },
      { label: '综艺', path: '/category/zongyi' },
      { label: '动漫', path: '/category/dongman' },
      { label: '短剧', path: '/category/duanju' },
      { label: '纪录片', path: '/category/jilupian' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', path: '/about' },
      { label: '联系方式', path: '/about#contact' },
      { label: '用户协议', path: '/about' },
      { label: '隐私政策', path: '/about' },
    ],
  },
  {
    title: '帮助支持',
    links: [
      { label: '常见问题', path: '/about' },
      { label: '意见反馈', path: '/about' },
      { label: '广告合作', path: '/about' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap cursor-pointer">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-play-fill text-background-50 text-lg"></i>
              </div>
              <span className="text-xl font-bold text-foreground-950 font-heading">
                黄瓜<span className="text-primary-500">tv</span>
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              黄瓜tv - 高清视频在线观看平台，提供海量影视资源、流畅播放体验与丰富内容分类。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:text-primary-500 hover:bg-primary-100 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:text-primary-500 hover:bg-primary-100 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:text-primary-500 hover:bg-primary-100 transition-colors cursor-pointer" aria-label="邮箱">
                <i className="ri-mail-line text-sm"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">{group.title}</h4>
              <ul className="flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="border-t border-background-200/70">
        <div className="w-full px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © 2026 黄瓜tv 版权所有 | 京ICP备2024000001号-1
          </p>
          <p className="text-xs text-foreground-500">
            黄瓜tv在线观看 - 高清视频在线播放平台
          </p>
        </div>
      </div>
    </footer>
  );
}